import { createReducer, createSelector } from 'redux-starter-kit';
import {
  putUser, putUsers, invalidateUsers, addUsers, removeUser,
} from './userActions';


/**
 * A selector for a user in the domain.
 * @param {object} state The redux state for the application.
 * @param {string} userId The id of the user.
 */
export const selectUser = (state, userId) => state.via.domain.users[userId];

/**
 * A selector for all the users in the domain
 * @param {object} state The redux state
 * @returns A map of username to the user
 */
export const selectUsersMap = state => state.via.domain.users;

/**
 * A selector for the users loaded in the domain state.
 * Turns the map into a list for use in tables
 * @param {object} state The redux state of the application.
 * @returns An array of user objects.
 */
export const selectUsers = createSelector(['via.domain.users'], map => (map ? Object.values(map) : null));


// A dict object with a property key of: userId and a property value of: user.
const initialUserState = {
  // userId: { /* user object */ },
  // userId: { /* user object */ },
  // ...etc
};

const usersReducer = createReducer(initialUserState, {
  // Puts a user into the store.
  [putUser]: (state, action) => {
    const user = action.payload;

    return {
      ...state,
      [user.userId]: user,
    };
  },

  [putUsers]: (state, action) => {
    const users = action.payload;
    return users.reduce((newState, user) => {
      newState[user.userId] = user;// eslint-disable-line no-param-reassign
      return newState;
    }, { ...initialUserState });
  },

  [removeUser]: (state, action) => {
    const userId = action.payload;
    const newState = { ...state };
    delete newState[userId];
    return newState;
  },


  // Adds users into the store.
  [addUsers]: (state, action) => {
    const users = action.payload;

    return users.reduce((newState, user) => {
      newState[user.userId] = user; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...state });
  },

  // Removes all users from the store.
  [invalidateUsers]: () => initialUserState,
});

export default usersReducer;
